// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"4f9d458c","305":"71b3e04b","375":"36b73f20","453":"bbe8048d","560":"63231107","789":"ea64e0e8","935":"05ab3268","978":"a0a4899d","979":"640dc89f"}[chunkId] + ".chunk.js";
};